import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useVerifySignInMutation } from '@/apis/extended/authApi';
import { navigateByRole } from '@/components/Auth/authnavigation';
import { Loader } from '@/components/Layout/Loader';
import { VerifyFailed } from '@/components/Verify/VerifyFailed';
import { VerifySuccess } from '@/components/Verify/VerifySuccess';
import { STATUS } from '@/types/CommonType';

const REDIRECT_DELAY_MS = 1500;

export const VerifySignInPage = () => {
  const [searchParams] = useSearchParams();
  const [verifySecurity] = useVerifySignInMutation();

  const [status, setStatus] = useState<STATUS>(STATUS.LOADING);

  useEffect(() => {
    const uid = searchParams.get('uid');
    if (!uid) return;

    let redirectTimer: ReturnType<typeof setTimeout> | undefined;

    verifySecurity(uid)
      .unwrap()
      .then((res) => {
        setStatus(STATUS.SUCCESS);
        const { user, role } = res;
        if (role) {
          redirectTimer = setTimeout(() => {
            navigateByRole(role, user?._id, {
              onboardingCompleted: user?.onboardingCompleted,
            });
          }, REDIRECT_DELAY_MS);
        }
      })
      .catch(() => setStatus(STATUS.FAILED));

    return () => clearTimeout(redirectTimer);
  }, [searchParams]);

  if (status === STATUS.LOADING) return <Loader isFull />;
  if (status === STATUS.FAILED) return <VerifyFailed />;
  return <VerifySuccess />;
};
